/**
 * @file Shared "could not load" state.
 *
 * Pages used to fail silently in two ways: an uncaught fetch rejection left a
 * skeleton on screen forever, and watch* errors only console.error'd — so a
 * rules regression or a network blip looked identical to "still loading",
 * with no signal and no way to retry. Both now render this.
 */

import { el } from '../utils.js';
import { Icons } from '../icons.js';

/**
 * @param message  what failed, in admin language
 * @param onRetry  optional retry handler — renders a Retry button
 */
export function renderLoadError(message, onRetry = null) {
  const retry = onRetry
    ? el('button', { class: 'btn-sm btn-outline btn', style: 'margin-top:12px' }, 'Retry')
    : null;
  if (retry) retry.addEventListener('click', () => onRetry());
  return el('div', { class: 'empty' },
    Icons.bell(),
    el('p', null, message),
    el('p', { class: 'muted' }, 'This is usually a connection hiccup. If it persists, check the browser console.'),
    retry,
  );
}
